// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1aile330 {\n  color: #000;\n  font-weight: 700;\n  font-size: 18px;\n  margin: 5px 0 0 0;\n}", ""]);
// Exports
module.exports = exports;
